module.exports = __webpack_public_path__ + "static/img/s06.3304f05d.png";